import type { LoaderFunctionArgs } from '@remix-run/node'
import { typedjson, useTypedLoaderData } from 'remix-typedjson'
import { BlogPostBanner, Byline } from '~/components'
import postStyles from '~/styles/pages/page.css?url'
import pageStyles from '~/styles/pages/post.css?url'
import { z } from 'zod'
import { zx } from 'zodix'
import { blogPostRenderOption } from '~/utils/contentful'
import { rudderStack } from '~/utils/rudder-stack.server'
import { H2 } from '~/components-v2'
import { getBlogPostBySlug } from '~/services/contentful/blog.server'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { styles } from '~/components-v2'
import { codeBlockLinks } from '~/components-v2/code-block'

export const links = () => [
  { rel: 'stylesheet', href: postStyles },
  { rel: 'stylesheet', href: pageStyles },
  ...codeBlockLinks(),
  { rel: 'stylesheet', href: styles.anchorReveal },
  { rel: 'stylesheet', href: styles.figure },
]

export { meta } from '~/utils'

export const loader = async ({ params, request }: LoaderFunctionArgs) => {
  const { slug } = zx.parseParams(params, { slug: z.string() })

  try {
    const post = await getBlogPostBySlug(slug)
    rudderStack(request, post.title, 'blog-post')
    return typedjson(post)
  } catch {
    throw new Response('Post not found', { status: 404 })
  }
}

export default function () {
  const loaderData = useTypedLoaderData<typeof loader>()
  const { body, title, subtitle, authors, banner, published } = loaderData

  return (
    <div className="blog-post">
      <header className="page">
        <h1>{title}</h1>
        {subtitle && (
          <H2 color="text4" fontSize="xxl">
            {subtitle}
          </H2>
        )}
      </header>
      <Byline authors={authors} date={published} />
      <article>
        {banner && <BlogPostBanner loading="eager" {...banner} />}
        {typeof body === 'string' ? (
          <div dangerouslySetInnerHTML={{ __html: body }} />
        ) : (
          documentToReactComponents(body, blogPostRenderOption)
        )}
      </article>
    </div>
  )
}
